import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, inject, input, signal } from '@angular/core';

import { EMPTY, catchError, finalize, switchMap, tap } from 'rxjs';

import { TranslatePipe } from '@camelot/translation';
import { CamBaseComponent } from '@camelot/utils';

import { CamGridData } from '../../../models/grid-data';
import { FooterEntry, IFooterDataService } from '../../../models/types';
import { CamGridDataService } from '../../../services/grid-data.service';
import { CamTranslationGrid } from '../../../translation.service';

@Component({
  imports: [CurrencyPipe, TranslatePipe],
  selector: 'cam-ag-grid-footer',
  styleUrl: './ag-grid-footer.component.scss',
  templateUrl: './ag-grid-footer.component.html',
})
export class AgGridFooterComponent extends CamBaseComponent implements OnInit {
  gridId = input.required<string>();

  services = input<IFooterDataService | null>(null);

  readonly entries = signal<FooterEntry[]>([]);

  private _grid!: CamGridData<any>;
  private _dataService = inject<CamGridDataService<any>>(CamGridDataService);

  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }

  ngOnInit() {
    this._grid = this._dataService.get(this.gridId());
    this._loadFooter();

    this._registerSubscription(this._grid.dataUpdated$.pipe(switchMap(() => this._fetchFooter$())).subscribe());
  }

  private _loadFooter() {
    if (!this.services()) {
      return;
    }

    this._registerSubscription(this._fetchFooter$().subscribe());
  }

  private _fetchFooter$() {
    this.requestState.asked();

    return this.services()!
      .getFooter$()
      .pipe(
        tap(entries => {
          this.entries.set(entries);
        }),
        catchError(() => EMPTY),
        finalize(() => {
          this.requestState.completed();
        })
      );
  }
}
